module.exports = __webpack_public_path__ + "static/media/20210403_204343_101_IMG_0001.2144a32b.jpg";